import { render, staticRenderFns } from "./infoDialog.vue?vue&type=template&id=dde781f4&scoped=true"
import script from "./infoDialog.vue?vue&type=script&lang=js"
export * from "./infoDialog.vue?vue&type=script&lang=js"
import style0 from "./infoDialog.vue?vue&type=style&index=0&id=dde781f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde781f4",
  null
  
)

export default component.exports